/**
 * Utility functions for DataTable component
 */

/**
 * Creates a text filter column definition
 */
export const createTextFilterColumn = (columnDef) => ({
  ...columnDef,
  enableColumnFilter: true,
  filterFn: "includesString",
});

/**
 * Creates a select filter column definition
 */
export const createSelectFilterColumn = (columnDef, options = []) => ({
  ...columnDef,
  enableColumnFilter: true,
  filterFn: "equals",
  meta: {
    filterType: "select",
    options,
  },
});

/**
 * Creates a date filter column definition
 */
export const createDateFilterColumn = (columnDef) => ({
  ...columnDef,
  enableColumnFilter: true,
  filterFn: "equals",
  meta: {
    filterType: "date",
  },
});

/**
 * Helper to format currency values
 */
export const formatCurrency = (value) => {
  if (value === null || value === undefined) return "$0.00";
  return `$${parseFloat(value).toFixed(2)}`;
};

/**
 * Helper to format date values
 */
export const formatDate = (value, format = "MMM DD, YYYY") => {
  if (!value) return "N/A";
  const moment = require("moment");
  return moment(value).format(format);
};

/**
 * Creates a column definition with common defaults
 */
export const createColumn = ({
  id,
  header,
  accessorKey,
  accessorFn,
  cell,
  enableSorting = true,
  enableFiltering = false,
  width,
  minSize,
  maxSize,
  ...rest
}) => ({
  id,
  header,
  ...(accessorKey && { accessorKey }),
  ...(accessorFn && { accessorFn }),
  ...(cell && { cell }),
  enableSorting,
  enableColumnFilter: enableFiltering,
  ...(width && { size: width }),
  ...(minSize && { minSize }),
  ...(maxSize && { maxSize }),
  ...rest,
});

